import {
  FormControl,
  Select,
  MenuItem,
  Box,
  Grid,
  Autocomplete,
  TextField,
  Checkbox,
} from "@mui/material";
import React, { ReactElement, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import ClearIcon from "@mui/icons-material/Clear";
import ListItemText from "@mui/material/ListItemText";
import {
  displayFolderList,
  displayFolderListError,
  displayFolderListSuccess,
  displayScenarioList,
  displayScenarioListError,
  displayScenarioListSuccess,
  openErrorDialog,
} from "../../../Redux/Actions/InputData";
import { getRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  DISPLAY_CHART_BASELINE_CO2_API,
  LT_DISPLAY_CHART_BASELINE_COST_API,
  DISPLAY_CHART_COST_PER_TON_API,
  DISPLAY_CHART_COST_PER_TON_BY_TIME_PERIOD_API,
  DISPLAY_CHART_DISTANCE_PER_TON_API,
  DISPLAY_CHART_DISTANCE_PER_TON_BY_TIME_PERIOD_API,
  DISPLAY_CHART_OVER_All_CO2_BY_TIME_PERIOD_API,
  DISPLAY_CHART_OVER_All_COST_BY_TIME_PERIOD_API,
  // DISPLAY_FOLDER_LIST_BY_USECASE_API,
  // DISPLAY_SCENARIO_FILTER_API,
  NUTRITION_DISPLAY_CHART_BASELINE_CO2_API,
  NUTRITION_DISPLAY_CHART_BASELINE_COST_API,
  NUTRITION_DISPLAY_CHART_COST_PER_TON_API,
  NUTRITION_DISPLAY_CHART_COST_PER_TON_BY_TIME_PERIOD_API,
  NUTRITION_DISPLAY_CHART_DISTANCE_PER_TON_API,
  NUTRITION_DISPLAY_CHART_DISTANCE_PER_TON_BY_TIME_PERIOD_API,
  NUTRITION_DISPLAY_CHART_OVER_All_CO2_BY_TIME_PERIOD_API,
  NUTRITION_DISPLAY_CHART_OVER_All_COST_BY_TIME_PERIOD_API,
  LONG_GETALLFOLDERS_API,
  LT_DISPLAY_SCENARIO_FILTER_API,
  LT_DISPLAY_CHART_COST_PER_TON_API,
  LT_DISPLAY_CHART_BASELINE_CO2_API,
  LT_DISPLAY_CHART_DISTANCE_PER_TON_API,
} from "../../../Utils/Config";
import CostPerTonByScenarioChart from "./CostPerTonByScenarioChart";
import DistancePerTonChart from "./DistancePerTonChart";
import OverAllCostByScenarioChart from "./OverAllCostByScenarioChart";
import OverAllCo2ByScenarioChart from "./OverAllCo2tByScenarioChart";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import btnDownloadIcon from "./../../../Assests/download.svg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { AnyNaptrRecord } from "dns";

interface Scenario {
  scenario_id: number;
  folder_id: number;
  scenario: string;
}

// import TestStackChart from "./TestStackChart";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
function CompareCharts(props: any) {
  const autocompleteRef: any = useRef();
  const [selectFolder, setSelectFolder] = useState<any>("Folder");
  const [selectedInnerFolderId, setSelectedInnerFolderId] = useState<any>(0);
  const [folderOptions, setFolderOptions] = useState<any>([]);
  const [selectScenario1, setSelectScenario1] = useState<any>("Baseline");
  const [selectScenario2, setSelectScenario2] = useState<any>("Scenario ");
  const [selectScenario1Id, setSelectScenario1Id] = useState<any>(0);
  const [selectScenario2Id, setSelectScenario2Id] = useState<any>(0);
  const [selectBaseline, setSelectBaseline] = useState<any>("Baseline");
  const [tabsValue, setTabsValue] = React.useState("1");

  //const [selectedScenarioId, setSelectedScenarioId] = useState<any>(0);
  const [scenarioOptions, setScenarioOptions] = useState<any>([]);
  const [secondScenarioOptions, setSecondScenarioOptions] = useState<any>([]);
  const dispatch: any = useDispatch();
  const [overAllCostData, setOverAllCostData] = React.useState([]);
  const [nutritionOverAllCostData, setNutritionOverAllCostData] =
    React.useState([]);
  const [overAllCo2Data, setOverAllCo2Data] = React.useState([]);
  const [nutritionOverAllCo2Data, setNutritionOverAllCo2Data] = React.useState(
    []
  );
  const [costPerTonData, setCostPerTonData] = React.useState([]);
  const [nutritionCostPerTonData, setNutritionCostPerTonData] = React.useState(
    []
  );
  // const [timePeriodCostPerTonData, setTimePeriodCostPerTonData] = React.useState({labels:["Jan","Feb"],values:[{data:[34.64,28.33,34.89],backgroundcolor:"#001F82"},{data:[34.69,22.33,38.89],backgroundcolor:"#00B2FF"}]});
  // ex const [timePeriodCostPerTonData, setTimePeriodCostPerTonData] = React.useState({labels:["Jan","Feb"],values:[{data:[34.64,28.33,34.89],backgroundcolor:"#001F82"},{data:[34.69,22.33,38.89],backgroundcolor:"#00B2FF"}]});
  // imp const [timePeriodCostPerTonData, setTimePeriodCostPerTonData] = React.useState({"label":["01-01-2023","01-02-2023","1.2023"],"data":[{"data":[18690,4579,0],"backgroundColor":"#001F82","stack":"Stack 1","barThickness":16,"barPercentage":0,"borderColor":"white","borderWidth":{"top":0,"left":3,"right":3},"timeperiod":null,"cost":"Landed Cost"},{"data":[3080,5410,0],"backgroundColor":"#9C44C0","stack":"Stack 1","barThickness":16,"barPercentage":0,"borderColor":"white","borderWidth":{"top":0,"left":3,"right":3},"timeperiod":null,"cost":"Conversion Cost"},{"data":[0,0,3004.08],"backgroundColor":"#00B2FF","stack":"Stack 1","barThickness":16,"barPercentage":0,"borderColor":"white","borderWidth":{"top":0,"left":3,"right":3},"timeperiod":null,"cost":"Pri Transportation Cost"},{"data":[11473,0,0],"backgroundColor":"#001F82","stack":"Stack 2","barThickness":16,"barPercentage":0,"borderColor":"white","borderWidth":{"top":0,"left":3,"right":3},"timeperiod":null,"cost":"Landed Cost"},{"data":[380140.72,380140.72,0],"backgroundColor":"#9C44C0","stack":"Stack 2","barThickness":16,"barPercentage":0,"borderColor":"white","borderWidth":{"top":0,"left":3,"right":3},"timeperiod":null,"cost":"Conversion Cost"},{"data":[62909.88,62909.88,0],"backgroundColor":"#00B2FF","stack":"Stack 2","barThickness":16,"barPercentage":0,"borderColor":"white","borderWidth":{"top":0,"left":3,"right":3},"timeperiod":null,"cost":"Pri Transportation Cost"}]});
  const [timePeriodCostPerTonData, setTimePeriodCostPerTonData] =
    React.useState({ label: [], data: [] });
  const [
    nutritionTimePeriodCostPerTonData,
    setNutritionTimePeriodCostPerTonData,
  ] = React.useState({ label: [], data: [] });
  const [timePeriodOverAllCost, setTimPeriodOverAllCost] = React.useState({
    label: [],
    data: [],
  });
  const [nutritionTimePeriodOverAllCost, setNutritionTimPeriodOverAllCost] =
    React.useState({ label: [], data: [] });
  const [timePeriodOverAllCo2, setTimePeriodOverAllCo2] = React.useState({
    label: [],
    data: [],
  });
  const [nutritionTimePeriodOverAllCo2, setNutritionTimePeriodOverAllCo2] =
    React.useState({ label: [], data: [] });
  // const [timePeriodDistanceData, setTimePeriodDistanceData] = React.useState({labels:["Jan","Feb"],values:[{data:[34.64,28.33,34.89],backgroundcolor:"#001F82"},{data:[34.69,22.33,38.89],backgroundcolor:"#00B2FF"}]});
  //const [timePeriodDistanceData, setTimePeriodDistanceData] = React.useState({ labels : ['1.2023','2.2023','01-01-2023','02-02-2023'],  values : [{ data :[1535.20,931.91,0,0,], backgroundcolor: '#001F82' },{ data : [0,0,74.00,74.00,], backgroundcolor: '#00B2FF' }] } );
  // const [timePeriodDistanceData, setTimePeriodDistanceData] = React.useState({labels:['1.2023','2.2023'],values:[{data:[1535.20,931.91],backgroundcolor:'#001F82'},{data:[1535.20,931.91],backgroundcolor:'#00B2FF'}]});
  const [timePeriodDistanceData, setTimePeriodDistanceData] = React.useState(
    []
  );
  const [nutritionTimePeriodDistanceData, setNutritionTimePeriodDistanceData] =
    React.useState([]);
  // const [timePeriodDistanceData, setTimePeriodDistanceData] = React.useState({"labels":["1.2023","2.2023","01-01-2023","02-02-2023"],"datasets":[{"data":[[1535.2,931.91,101,120],[74,74,60,80]],"backgroundColor":"#001F82"}]});
  const [distanceCostPerTonData, setDistanceCostPerTonData] = React.useState(
    []
  );
  const [nutritionDistanceCostPerTonData, setNutritionDistanceCostPerTonData] =
    React.useState([]);
  // const overAllCostData = [{"inbound_transportation_cost":0.52556780000,"production_cost":25.92506494500,"procurement_cost":31.15005122300,"pri_transportation_cost_outbound_cost":79.68806293800,"total_cost":137.28870000000,"total_cost_per_ton":0.15080000000,"chartname":"Baseline"},{"inbound_transportation_cost":35.3213241950000,"production_cost":16.1031722750000,"procurement_cost":28.0437296250000,"pri_transportation_cost_outbound_cost":12.0193286010000,"total_cost":19.1876000000000,"total_cost_per_ton":54.0002000000000,"chartname":"Scenario"}];

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  const selectedUploadScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedUploadScenarioId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const loadInitialData = () => {
    if (selectedFolderId > 0 && folderOptions.length > 0) {
      setSelectedInnerFolderId(selectedFolderId);
      const folderItem = folderOptions.find((obj: any) => {
        return obj.id === selectedFolderId;
      });
      if (folderItem != null) {
        setSelectFolder(folderItem?.folder);
        console.log("Tab2");
        callScenarioFilterApi(folderItem?.id);
        //loadScenarios(scenarioOptions.length > 0 ?scenarioOptions[0].scenario_id : 0);
        setSelectScenario1("Baseline");
        setSelectScenario2("Scenario");
        loadCharts(
          selectedFolderId,
          0,
          selectedScenarioId ? selectedScenarioId : 0
        );
      }
    }
  };

  useEffect(() => {
    callFolderFilterApi();
  }, [selectedFolderId]);

  useEffect(() => {
    if (selectedScenarioId > 0) setScenarioValues(selectedScenarioId);
    loadCharts(selectedFolderId, selectScenario1Id, selectedScenarioId);
  }, [selectedScenarioId]);

  const setScenarioValues = (scenarioId: any) => {
    const folderNewItem = secondScenarioOptions?.find((obj: any) => {
      return obj.scenario_id === scenarioId;
    });
    setSelectScenario2(folderNewItem?.scenario);
  };
  const setIitialValues = () => {
    setOverAllCostData([]);
    setNutritionOverAllCostData([]);
    setOverAllCo2Data([]);
    setNutritionOverAllCo2Data([]);
    setCostPerTonData([]);
    setNutritionCostPerTonData([]);
    setTimePeriodCostPerTonData({ label: [], data: [] });
    setNutritionTimePeriodCostPerTonData({ label: [], data: [] });
    setTimPeriodOverAllCost({ label: [], data: [] });
    setNutritionTimPeriodOverAllCost({ label: [], data: [] });
    setTimePeriodOverAllCo2({ label: [], data: [] });
    setNutritionTimePeriodOverAllCo2({ label: [], data: [] });
    setSelectFolder("Folder");
    setSelectedSce([]);
    setScenarioOptions([]);
    setScenarioOptions([]);
    setSecondScenarioOptions([]);
    setSelectScenario1("Baseline");
    setSelectScenario2("Scenario");
  };
  const selectedScnarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );
  useEffect(() => {
    callFolderFilterApi();
    setIitialValues();
  }, [selectedUsecaseId, selectedCategoryId]);

  useEffect(() => {
    setIitialValues();
    loadInitialData();
  }, [folderOptions]);

  const callFolderFilterApi = () => {
    dispatch(displayFolderList());
    const urls = API_BASE_URL + LONG_GETALLFOLDERS_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(urls, {}, header)
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setFolderOptions(response.data.data);
          dispatch(displayFolderListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayFolderListError(error.message));
      });
  };

  const handleDownload = (e: any) => {
    let elem: any = document.getElementById("chartcontainer");
    html2canvas(elem).then(function (canvas) {
      var wid: number;
      var hgt: number;
      var img = canvas.toDataURL("image/png", (wid = canvas.width));
      // var img = canvas.toDataURL("image/png", wid = canvas.width, hgt = canvas.height);
      // var hratio = hgt/wid
      var doc = new jsPDF("p", "pt", "a4");
      var width = 550; // doc.internal.pageSize.width;
      var height = 600; // width * hratio
      doc.addImage(img, "JPEG", 10, 10, width, height);
      doc.save("Compare_Charts.pdf");
    });
  };

  /**Redux state */

  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData
  );
  let folderModuleName =
    selectedFolderData?.folder?.slice(0, 7) === "Module1"
      ? ""
      : selectedFolderData?.folder?.slice(0, 7);

  const overallCostByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls = API_BASE_URL + LT_DISPLAY_CHART_BASELINE_COST_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    // getRequest(urls, {"folder_id": selectedInnerFolderId, "scenario_id": selectScenario1Id}, header).then((response: any) => {
    getRequest(
      urls,
      {
        folder_id: folderId,
        // "scenario_id": selectedScnarioId
        scenario_id: scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response: any) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");
          setOverAllCostData(JSON.parse(modifiedJsonString));
          //    console.log("__________________________________", response.data.length);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };
  const overallCo2ByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL + LT_DISPLAY_CHART_BASELINE_CO2_API + folderModuleName;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    // getRequest(urls, {"folder_id": selectedInnerFolderId, "scenario_id": selectScenario1Id}, header).then((response: any) => {
    getRequest(
      urls,
      {
        folder_id: folderId,
        scenario_id: scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response: any) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "nutritionData");
          const modifiedJsonString = response.data.replace("[,{", "[{");
          setOverAllCo2Data(JSON.parse(modifiedJsonString));
          setNutritionOverAllCo2Data(JSON.parse(modifiedJsonString));
          //    console.log("__________________________________", response.data.length);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const costPerTonByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL + LT_DISPLAY_CHART_COST_PER_TON_API + folderModuleName;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    //getRequest(urls, {"folder_id": selectedInnerFolderId, "scenario_id": selectScenario1Id}, header).then((response) => {
    getRequest(
      urls,
      {
        folder_id: folderId,
        // "scenario_id": selectedScnarioId
        scenario_id: scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");
          setCostPerTonData(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const distanceCostPerTonByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls =
      API_BASE_URL + LT_DISPLAY_CHART_DISTANCE_PER_TON_API + folderModuleName;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    // getRequest(urls, {"folder_id": selectedInnerFolderId, "scenario_id": selectedScenarioId}, header).then((response) => {
    //let resultScenarioId =
    getRequest(
      urls,
      {
        folder_id: folderId,
        // "scenario_id": selectedScnarioId
        scenario_id: scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");
          //  console.log("First Distance grph From API", response.data)
          setDistanceCostPerTonData(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const CostPerTonByScenarioForTimePeriodApi = (
    folderId: number,
    scenario1Id: number,
    scenario2Id: number
  ) => {
    const urls = API_BASE_URL + DISPLAY_CHART_COST_PER_TON_BY_TIME_PERIOD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    // getRequest(urls, {"folder_id": selectedInnerFolderId, "scenario_id": selectedScenarioId}, header).then((response) => {
    //let resultScenarioId =
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        BaseLineOrScenarioId: scenario1Id,
        scenario_id: scenario2Id,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(
            "Cost per Ton For time Period grph From API",
            response.data
          );
          //console.log("Distance grph From API-new", JSON.parse(response.data))
          setTimePeriodCostPerTonData(response.data);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const nutritionOverallCostByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls =
      folderModuleName === "module1"
        ? API_BASE_URL + LT_DISPLAY_CHART_BASELINE_COST_API
        : folderModuleName !== undefined
        ? API_BASE_URL + LT_DISPLAY_CHART_BASELINE_COST_API + folderModuleName
        : API_BASE_URL + LT_DISPLAY_CHART_BASELINE_COST_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    // getRequest(urls, {"folder_id": selectedInnerFolderId, "scenario_id": selectScenario1Id}, header).then((response: any) => {
    getRequest(
      urls,
      {
        folder_id: folderId,
        // "scenario_id": selectedScnarioId
        scenario_id: scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response: any) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");
          setOverAllCostData(JSON.parse(modifiedJsonString));
          //    console.log("__________________________________", response.data.length);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const nutritionOverallCo2ByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls =
      folderModuleName === "module1"
        ? API_BASE_URL + LT_DISPLAY_CHART_BASELINE_CO2_API
        : folderModuleName !== undefined
        ? API_BASE_URL + LT_DISPLAY_CHART_BASELINE_CO2_API + folderModuleName
        : API_BASE_URL + LT_DISPLAY_CHART_BASELINE_CO2_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    // getRequest(urls, {"folder_id": selectedInnerFolderId, "scenario_id": selectScenario1Id}, header).then((response: any) => {
    getRequest(
      urls,
      {
        folder_id: folderId,
        scenario_id: scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response: any) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "nutritionData");
          const modifiedJsonString = response.data.replace("[,{", "[{");

          setNutritionOverAllCo2Data(JSON.parse(modifiedJsonString));
          //    console.log("__________________________________", response.data.length);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const nutritionCostPerTonByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls =
      folderModuleName === "module1"
        ? API_BASE_URL + LT_DISPLAY_CHART_COST_PER_TON_API
        : folderModuleName !== undefined
        ? API_BASE_URL + LT_DISPLAY_CHART_COST_PER_TON_API + folderModuleName
        : API_BASE_URL + LT_DISPLAY_CHART_COST_PER_TON_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    //getRequest(urls, {"folder_id": selectedInnerFolderId, "scenario_id": selectScenario1Id}, header).then((response) => {
    getRequest(
      urls,
      {
        folder_id: folderId,
        // "scenario_id": selectedScnarioId
        scenario_id: scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");
          setCostPerTonData(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };

  const nutritionDistanceCostPerTonByScenarioApi = (
    folderId: number,
    scenario1Id: any,
    scenario2Id: number
  ) => {
    const urls =
      folderModuleName === "module1"
        ? API_BASE_URL + LT_DISPLAY_CHART_DISTANCE_PER_TON_API
        : folderModuleName !== undefined
        ? API_BASE_URL +
          LT_DISPLAY_CHART_DISTANCE_PER_TON_API +
          folderModuleName
        : API_BASE_URL + LT_DISPLAY_CHART_DISTANCE_PER_TON_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    // getRequest(urls, {"folder_id": selectedInnerFolderId, "scenario_id": selectedScenarioId}, header).then((response) => {
    //let resultScenarioId =
    getRequest(
      urls,
      {
        folder_id: folderId,
        // "scenario_id": selectedScnarioId
        scenario_id: scenario1Id.length > 0 ? scenario1Id.toString() : 0,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          const modifiedJsonString = response.data.replace("[,{", "[{");
          //  console.log("First Distance grph From API", response.data)
          setDistanceCostPerTonData(JSON.parse(modifiedJsonString));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
      });
  };
  const [selectedSce, setSelectedSce] = useState<Scenario[]>([]);

  const handleChange = (event: any) => {
    const selectedValues = event.target.value as Scenario[];
    setSelectedSce(selectedValues);
    loadCharts(selectedInnerFolderId, selectedValues, selectScenario2Id);
  };

  const handleClear = () => {
    loadCharts(selectedInnerFolderId, [], selectScenario2Id);
    setSelectedSce([]);
  };

  const [selectedScenarios, setSelectedScenarios] = useState<any>([]);

  console.log(selectedScenarios, "selectedScenarios");

  const handleChangeSelectFolder = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectFolder(value.folder);
    setSelectedInnerFolderId(value.id);
    callScenarioFilterApi(value.id);
    setSelectedScenarios([]);
    loadCharts(selectedInnerFolderId, selectScenario1Id, 0);
  };

  const callScenarioFilterApi = (id: any) => {
    console.log("Tab1");
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + LT_DISPLAY_SCENARIO_FILTER_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(urls, { folder_id: id }, header)
      .then((response) => {
        if (response.status === 200 && response.data) {
          let responseArray = [];
          console.log(response.data, "resddsfsdfs");
          responseArray.push(response.data);
          setScenarioOptions(response.data);
          setSecondScenarioOptions(response.data);
          //console.log(scenarioOptions);
          dispatch(displayScenarioListSuccess(response.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const handleChangeSelectScenario2 = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectScenario2(value.scenario);
    setSelectScenario2Id(value.scenario_id);
    //distanceCostPerTonByScenarioApi123();
    loadCharts(selectedInnerFolderId, selectScenario1Id, value.scenario_id);
    // overallCostByScenarioApi(selectScenario1Id,value.scenario_id);
    // costPerTonByScenarioApi(selectScenario1Id,value.scenario_id);
    // distanceCostPerTonByScenarioApi(selectScenario1Id,value.scenario_id);

    // //TimePeriod
    // distanceCostByScenarioForTimePeriodApi(selectScenario1Id,value.scenario_id);
    //CostPerTonByScenarioForTimePeriodApi(selectScenario1Id,value.scenario_id);
  };

  const loadCharts = (
    folderId: number,
    selectedScenarios: any,
    scenario2Id: number
  ) => {
    const selectedScenarioIds: any = [];
    selectedScenarios.length > 0 &&
      selectedScenarios.map((scenario: any) =>
        selectedScenarioIds.push(scenario.scenario_id)
      );
    if (selectedCategoryId === 1) {
      overallCostByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      costPerTonByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      distanceCostPerTonByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      // //TimePeriod
      // distanceCostByScenarioForTimePeriodApi(folderId,selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,scenario2Id);
      // CostPerTonByScenarioForTimePeriodApi(folderId,selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,scenario2Id);
      // CostPOverAllCostPerScenarioForTimePeriodApi(folderId,selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,scenario2Id);
      //Co2
      overallCo2ByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      // OverAllCo2PerScenarioForTimePeriodApi(folderId,selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,scenario2Id);
    } else {
      nutritionOverallCostByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      nutritionCostPerTonByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      nutritionDistanceCostPerTonByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      //TimePeriod
      // nutritionDistanceCostByScenarioForTimePeriodApi(folderId,selectedScenarios,scenario2Id);
      // NutritionCostPerTonByScenarioForTimePeriodApi(folderId,selectedScenarios,scenario2Id);
      // NutritionCostPOverAllCostPerScenarioForTimePeriodApi(folderId,selectedScenarios,scenario2Id);
      //Co2
      nutritionOverallCo2ByScenarioApi(
        folderId,
        selectedScenarioIds.length > 0 ? selectedScenarioIds : 0,
        scenario2Id
      );
      // NutritionOverAllCo2PerScenarioForTimePeriodApi(folderId,selectedScenarios,scenario2Id);
    }
  };

  console.log("costPerTonData___", costPerTonData);

  console.log(selectedScenarios, selectedSce, "selectedScenariostabs");
  const getLegends: any = () => {
    switch (folderModuleName) {
      case "module1":
        return (
          <div className="tabs-area">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={tabsValue}>
                <TabPanel value="1" className="pb-0">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>
                      Primary Transportation cost
                    </p>
                    <p>
                      <span className="chartlegend production-cost"></span>
                      Packaging cost
                    </p>
                    <p>
                      <span className="chartlegend fixed-cost"></span>
                      SFG Transportation Cost
                    </p>

                    <p>
                      <span className="chartlegend inboundtransportation-cost"></span>
                      Processing Cost
                    </p>
                    <p>
                      <span className="chartlegend outboundtransportation-cost"></span>
                      RM/PM Transportation cost
                    </p>
                    <p>
                      <span className="chartlegend fixed-cost"></span>
                      RM/PM Procurement cost
                    </p>
                  </div>
                  <div id="chartcontainer" className="chart-area">
                    {/* <Tabs1Charts filterArray={distanceCostPerTonData}/> */}
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        );
        break;
      case "module2":
        return (
          <div className="tabs-area">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={tabsValue}>
                <TabPanel value="1" className="pb-0">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>
                      Primary Transportation cost/Tonne/Distance/CO2
                    </p>
                    <p>
                      <span className="chartlegend production-cost"></span>
                      Packaging cost/Tonne/CO2
                    </p>
                    <p>
                      <span className="chartlegend fixed-cost"></span>
                      SFG Transportation Cost/Tonne/Distance/ RMPM Landed Cost
                    </p>

                    <p>
                      <span className="chartlegend inboundtransportation-cost"></span>
                      Processing Cost/Tonne/CO2
                    </p>

                    {/* <p>
                    <span className="chartlegend outboundtransportation-cost"></span>
                    RM/PM Transportation cost
                  </p>
                  <p>
                    <span className="chartlegend fixed-cost"></span>
                    RM/PM Procurement cost
                  </p> */}
                  </div>
                  <div id="chartcontainer" className="chart-area">
                    {/* <Tabs1Charts filterArray={distanceCostPerTonData}/> */}
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        );
        break;
      case "module3":
        return (
          <div className="tabs-area">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={tabsValue}>
                <TabPanel value="1" className="pb-0">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>
                      Primary Transportation cost/Tonne/Distance/CO2
                    </p>
                    <p>
                      <span className="chartlegend production-cost"></span>
                      Packaging cost/Tonne/CO2
                    </p>
                    {/* <p>
                    <span className="chartlegend fixed-cost"></span>
                    SFG Transportation Cost
                  </p> */}

                    {/* <p>
                    <span className="chartlegend inboundtransportation-cost"></span>
                    Processing Cost
                  </p> */}
                    <p>
                      <span className="chartlegend outboundtransportation-cost"></span>
                      RM/PM Transportation cost/Tonne/Distance/CO2
                    </p>
                    <p>
                      <span className="chartlegend fixed-cost"></span>
                      RM/PM Procurement cost/Tonne/CO2
                    </p>
                  </div>
                  <div id="chartcontainer" className="chart-area">
                    {/* <Tabs1Charts filterArray={distanceCostPerTonData}/> */}
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        );
        break;
      case "module4":
        return (
          <div className="tabs-area">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={tabsValue}>
                <TabPanel value="1" className="pb-0">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>
                      Primary Transportation cost/Tonne/Distance/CO2
                    </p>
                    <p>
                      <span className="chartlegend production-cost"></span>
                      Packaging cost/Tonne/CO2
                    </p>
                    {/* <p>
                    <span className="chartlegend fixed-cost"></span>
                    SFG Transportation Cost
                  </p> */}

                    {/* <p>
                    <span className="chartlegend inboundtransportation-cost"></span>
                    Processing Cost
                  </p> */}
                    {/* <p>
                    <span className="chartlegend outboundtransportation-cost"></span>
                    RM/PM Transportation cost
                  </p> */}
                    <p>
                      <span className="chartlegend fixed-cost"></span>
                      RMPM Landed cost/Tonne
                    </p>
                  </div>
                  <div id="chartcontainer" className="chart-area">
                    {/* <Tabs1Charts filterArray={distanceCostPerTonData}/> */}
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        );
        break;
      case "module5":
        return (
          <div className="tabs-area">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={tabsValue}>
                <TabPanel value="1" className="pb-0">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>
                      Primary Transportation cost/Tonne/Distance/CO2
                    </p>
                    <p>
                      <span className="chartlegend production-cost"></span>
                      Packaging cost/Tonne/CO2
                    </p>
                    <p>
                      <span className="chartlegend fixed-cost"></span>
                      SFG Transportation Cost/Tonne/Distance/CO2
                    </p>

                    <p>
                      <span className="chartlegend inboundtransportation-cost"></span>
                      Processing Cost/Tonne/CO2
                    </p>
                    <p>
                      <span className="chartlegend outboundtransportation-cost"></span>
                      RMPM Transportation cost/Tonne/Distance/CO2
                    </p>
                    <p>
                      <span className="chartlegend fixed-cost"></span>
                      RM/PM Procurement cost/Tonne/CO2
                    </p>
                  </div>
                  <div id="chartcontainer" className="chart-area">
                    {/* <Tabs1Charts filterArray={distanceCostPerTonData}/> */}
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        );
        break;
      case "module6":
        return (
          <div className="tabs-area">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={tabsValue}>
                <TabPanel value="1" className="pb-0">
                  <div className="legend-area">
                    <p className="legend-title">Legend</p>
                    <p>
                      <span className="chartlegend procurement-cost"></span>
                      Primary Transportation cost/Tonne/Distance/CO2
                    </p>
                    <p>
                      <span className="chartlegend production-cost"></span>
                      Packaging cost/Tonne/CO2
                    </p>
                    <p>
                      <span className="chartlegend outboundtransportation-cost"></span>
                      SFG Transportation Cost/Tonne/Distance/CO2
                    </p>

                    <p>
                      <span className="chartlegend inboundtransportation-cost"></span>
                      Processing Cost/Tonne/CO2
                    </p>
                    {/* <p>
                    <span className="chartlegend outboundtransportation-cost"></span>
                    RM/PM Transportation cost
                  </p> */}
                    <p>
                      <span className="chartlegend fixed-cost"></span>
                      RMPM Landed cost
                    </p>
                  </div>
                  <div id="chartcontainer" className="chart-area">
                    {/* <Tabs1Charts filterArray={distanceCostPerTonData}/> */}
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        );
        break;
      default:
        return "";
    }
  };
  return (
    <>
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Compare scenarios</h3>
          </div>
          <div className="filters">
            <div className="filter-item" style={{ backgroundColor: "white" }}>
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-2"
                  value={selectFolder}
                  placeholder="Select Folder"
                  onChange={handleChangeSelectFolder}
                  renderValue={(selected: any) => selected}
                  className="select-short-term"
                >
                  {folderOptions.map((d: any) => {
                    return (
                      <MenuItem key={d.id} value={d}>
                        {/* {d.folder + " (" + d.time_period + ")"} */}
                        {d.folder}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <FormControl sx={{ width: 300 }}>
              <InputLabel id="demo-multiple-checkbox-label">
                Select Scenarios
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={selectedSce}
                onChange={handleChange}
                input={
                  <OutlinedInput
                    label="Select Scenarios"
                    endAdornment={
                      selectedSce.length > 0 && (
                        <ClearIcon
                          style={{ cursor: "pointer" }}
                          onClick={handleClear}
                        />
                      )
                    }
                  />
                }
                renderValue={(selected) =>
                  selected.map((item: any) => item.scenario).join(", ")
                }
              >
                {scenarioOptions.map((scenario: any) => (
                  <MenuItem key={scenario.scenario_id} value={scenario}>
                    <Checkbox checked={selectedSce.indexOf(scenario) > -1} />
                    <ListItemText primary={scenario.scenario} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* <FormControl fullWidth>
                <Autocomplete
                  value={selectedScenarios}
                  multiple
                  id="scenario-multi-select"
                  options={scenarioOptions}
                  disableCloseOnSelect
                  getOptionLabel={(option: any) => option.scenario}
                  onChange={handleChangeSelectScenario1}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.scenario}

                    </li>
                  )}
                  style={{ width: 300 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // label="Baseline"
                       value={params.inputProps.value}
                      // placeholder="Baseline"
                    />
                  )}
                />
              </FormControl> */}

            {/* <div className="filter-item" style={{ backgroundColor: "white" }}>
              <FormControl fullWidth>
                <Select
                  id="simple-select-3"
                  value={selectScenario2}
                  placeholder="Select Scenario"
                  onChange={handleChangeSelectScenario2}
                  renderValue={(selected: any) => selected}
                  className="select-short-term"
                >
                  {secondScenarioOptions.map((d: any) => {
                    return (
                      <MenuItem key={d.scenario_id} value={d}>
                        {d.scenario}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div> */}
            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className="content-download-btn"
                  data-html2canvas-ignore="true"
                  onClick={handleDownload}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
        {getLegends()}
      </div>

      <div>
        <div className="costPerTonChart">
          <OverAllCostByScenarioChart
            timPeriodOverAllCost={timePeriodOverAllCost}
            overAllCostData={overAllCostData}
          />
        </div>
        <div className="costPerTonChart">
          <CostPerTonByScenarioChart
            timePeriodCostPerTonData={timePeriodCostPerTonData}
            costPerTonData={costPerTonData}
          />
        </div>
        <div className="costPerTonChart">
          <DistancePerTonChart
            timePeriodDistanceData={timePeriodDistanceData}
            distnaceCostPerTonData={distanceCostPerTonData}
          />
        </div>
        <div className="costPerTonChart">
          <OverAllCo2ByScenarioChart
            timePeriodOverAllCo2={timePeriodOverAllCo2}
            overAllCo2Data={nutritionOverAllCo2Data}
          />
        </div>
        {/* <div className="utilizationPercentage">
          <UtilizationPercentage />
        </div> */}
        {/* <div>
          <TestStackChart />
        </div> */}
      </div>
    </>
  );
}
export default CompareCharts;
